'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n'], ['\n  font-size: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIIconButton = require('UIComponents/button/UIIconButton');

var _UIIconButton2 = _interopRequireDefault(_UIIconButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _mobileConstants = require('../constants/mobileConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IconStyles = _styledComponents2.default.span.withConfig({
  displayName: 'AttachButton__IconStyles'
})(_templateObject, function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? _mobileConstants.mobileIconFontSize : undefined;
});

var AttachButton = function AttachButton(props) {
  return _react2.default.createElement(
    _UIIconButton2.default,
    {
      disabled: props.disabled,
      onClick: props.onClick,
      use: 'link',
      style: { color: props.color },
      placement: 'top left',
      tooltip: props.tooltip
    },
    _react2.default.createElement(
      IconStyles,
      { isMobile: props.mobile },
      _react2.default.createElement(_UIIcon2.default, { name: 'attach' })
    )
  );
};

AttachButton.propTypes = {
  color: _react.PropTypes.string.isRequired,
  disabled: _react.PropTypes.bool,
  mobile: _react.PropTypes.bool,
  onClick: _react.PropTypes.func.isRequired,
  tooltip: _react.PropTypes.node
};

exports.default = AttachButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/attachments/AttachButton.js
// module id = 1166
// module chunks = 2 3